import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';

import Header from "../Header/Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from '../../pages/dashboard/Dashboard';
import Clienti from "../../pages/Clienti";
import AddCliente from "../../pages/AddCliente";
import EditCliente from "../../pages/EditCliente";
import Agenti from "../../pages/Agenti";
import AddAgente from "../../pages/AddAgente";
import EditAgente from "../../pages/EditAgente";
import Stipendi from "../../pages/Stipendi";
import AddStipendio from "../../pages/AddStipendio";
import EditStipendio from "../../pages/EditStipendio";
import Impostazioni from "../../pages/Impostazioni";
import Fatture from "../../pages/Fatture";
import AddFattura from "../../pages/AddFattura";
import Investimenti from "../../pages/Investimenti";
import AddInvestimento from "../../pages/AddInvestimento";
import EditInvestimento from "../../pages/EditInvestimento";
import UserSettings from "../../pages/UserSettings";
import EditFattura from "../../pages/EditFattura";
import F24 from "../../pages/F24";
import EditSpesa from "../../pages/EditSpesa";
import SpesePeriodiche from "../../pages/SpesePeriodiche";
import EditSpesaPeriodica from "../../pages/EditSpesaPeriodica";
import AddSpesaPeriodica from "../../pages/AddSpesaPeriodica";
import Fornitori from "../../pages/Fornitori";
import Prodotti from "../../pages/Prodotti";
import Ordini from "../../pages/Ordini";
import EditOrdine from "../../pages/EditOrdine";
import Preventivi from "../../pages/Preventivi";
import AddOrdine from "../../pages/AddOrdine";
import OrdiniFornitori from "../../pages/OrdiniFornitori";
import EditOrdineFornitore from "../../pages/EditOrdineFornitore";
import ConfermaOrdini from "../../pages/ConfermaOrdini";
import Ddt from "../../pages/Ddt";
import EditDdt from "../../pages/EditDdt";
import AddDdt from "../../pages/AddDdt";
import Funzionari from "../../pages/Funzionari";
import EditFunzionario from "../../pages/EditFunzionario";
import AddFunzionario from "../../pages/AddFunzionario";

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class Layout extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      menuItems: [],
      searchParams: '',
    }
  }

  searchGlobal(text) {
    this.setState({ searchParams: text });
    window.sessionStorage.setItem('search_text', text);
  }

  render() {

    // global
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <>
          <Header amministrazione history={this.props.history} onSearch={(s) => this.searchGlobal(s)} />
          <Sidebar menuItems={this.state.menuItems} />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: null,
            })}
          >
            <div className={classes.fakeToolbar} />

            <Switch>

              <Route path="/app/dashboard" component={Dashboard} />

              <Route path="/app/clienti" component={Clienti} />
              <Route path="/app/addCliente" component={AddCliente} />
              <Route path="/app/editCliente" component={EditCliente} />

              <Route path="/app/agenti" component={Agenti} />
              <Route path="/app/addAgente" component={AddAgente} />
              <Route path="/app/editAgente" component={EditAgente} />

              <Route path="/app/stipendi" component={Stipendi} />
              <Route path="/app/addStipendio" component={AddStipendio} />
              <Route path="/app/editStipendio" component={EditStipendio} />

              <Route path="/app/fatture" component={Fatture} />
              <Route path="/app/addFattura" component={AddFattura} />
              <Route path="/app/editFattura" component={EditFattura} />
              <Route path="/app/editSpesa" component={EditSpesa} />

              <Route path="/app/investimenti" component={Investimenti} />
              <Route path="/app/addInvestimento" component={AddInvestimento} />
              <Route path="/app/editInvestimento" component={EditInvestimento} />

              <Route path="/app/spesePeriodiche" component={SpesePeriodiche} />
              <Route path="/app/editSpesaPeriodica" component={EditSpesaPeriodica} />
              <Route path="/app/addSpesaPeriodica" component={AddSpesaPeriodica} />

              <Route path="/app/fornitori" component={Fornitori} />
              <Route path="/app/addFornitori" component={Fornitori} />

              <Route path="/app/ordini" component={Ordini} />
              <Route path="/app/addOrdine" component={AddOrdine} />
              <Route path="/app/edit-ordine" component={EditOrdine} />
              <Route path="/app/conferma-ordini" component={ConfermaOrdini} />

              <Route path="/app/preventivi" component={Preventivi} />
              <Route path="/app/ordini-fornitori" component={OrdiniFornitori} />
              <Route path="/app/edit-ordine-fornitore" component={EditOrdineFornitore} />

              <Route path="/app/prodotti" component={Prodotti} />

              <Route path="/app/ordini-fornitori" component={OrdiniFornitori} />

              <Route path="/app/f24" component={F24} />

              <Route path="/app/impostazioni" component={Impostazioni} />
              <Route path="/app/usersettings" component={UserSettings} />

              <Route path="/app/ddt" component={Ddt} />
              <Route path="/app/edit-ddt" component={EditDdt} />
              <Route path="/app/add-ddt" component={AddDdt} />

              <Route path="/app/funzionari" component={Funzionari} />
              <Route path="/app/addFunzionario" component={AddFunzionario} />
              <Route path="/app/editFunzionario" component={EditFunzionario} />

              <Route
                exact
                path="/app/ui"
                render={() => <Redirect to="/app/ui/icons" />}
              />
            </Switch>
          </div>
          <div
            className={classnames(classes.contentPhone)}
          >
          </div>
        </>
      </div>
    );
  }

}

export default withStyles(makeStyles)(withRouter(Layout));
